"use client";

import {useState} from "react";
import ActionsDrawer from "./ActionsDrawer";
import UserDrawer from "./UserDrawer";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
    Box,
    Button,
    IconButton,
    SwipeableDrawer,
    Tooltip,
} from "@mui/material";
import CasesDrawer from "./CaseDrawer/CasesDrawer";
import {useRouter} from "next/navigation";
import {navMap} from "../../../nav/navMap";
import {useTranslation} from "react-i18next";
import {useSession} from "next-auth/react";
import {useTheme} from "@mui/material";
import {MenuOutlined} from "@mui/icons-material";
import {useRecentActions} from "../context/RecentActionContext";
import DrawersController from "./DrawersControler";

export default function Header() {
    const router = useRouter();
    const theme = useTheme();

    const {t, i18n} = useTranslation("common");
    const currentLocale = i18n.language;
    const {data: session, status} = useSession();

    const toMainMenu = () => {
        router.push(navMap.locale(currentLocale).legal());
    };
    const [openUserDrawer, setOpenUserDrawer] = useState<boolean>(false);
    const matchMobile = useMediaQuery("(max-width: 600px");

    const {setOpenDrawer, openDrawer} = useRecentActions();

    const [openMenu, setOpenMenu] = useState(false);

    const changeOpenMenu = () => {
        setOpenMenu(!openMenu);
    };

    return (
        <>
            <ActionsDrawer
                setOpenUserDrawer={setOpenUserDrawer}
                setOpenMenu={setOpenMenu}
                openMenu={openMenu}
                openUserDrawer={openUserDrawer}
            />
            <UserDrawer
                openUserDrawer={openUserDrawer}
                setOpenUserDrawer={setOpenUserDrawer}
                setOpenMenu={setOpenMenu}
                openMenu={openMenu}
            />
            {matchMobile ? (
                <>
                    <Box
                        sx={{
                            zIndex: 10,
                            position: "absolute",
                            top: 1,
                            display: "flex",
                            minHeight: "64px",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "95%",
                        }}
                    >
                        <Tooltip title={t("back-main-page")}>
                            <Button onClick={toMainMenu}>
                                <img
                                    src={theme.logo}
                                    alt="Logo AI4Legal"
                                    height={40}
                                    style={{padding: "4px"}}
                                />
                            </Button>
                        </Tooltip>
                        {status === "authenticated" &&
                            session.user.role !== "NO_LICENCE" && <CasesDrawer />}
                        <IconButton
                            onClick={() => {
                                setOpenMenu(!openMenu);
                            }}
                        >
                            <MenuOutlined />
                        </IconButton>

                        <SwipeableDrawer
                            sx={{
                                flexShrink: 0,
                                [`& .MuiDrawer-paper`]: {height: "fit-content"},
                            }}
                            open={openMenu}
                            onClose={changeOpenMenu}
                            onOpen={changeOpenMenu}
                            anchor="right"
                        >
                            <DrawersController
                                setOpenDrawer={setOpenDrawer}
                                setOpenUserDrawer={setOpenUserDrawer}
                                setOpenMenu={setOpenMenu}
                                openUserDrawer={openUserDrawer}
                                openMenu={openMenu}
                                openDrawer={openDrawer}
                            />
                        </SwipeableDrawer>
                    </Box>
                </>
            ) : (
                <>
                    <Box
                        sx={{
                            zIndex: 10,
                            position: "absolute",
                            top: 1,
                            display: "flex",
                            minHeight: "64px",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "18vw",
                            minWidth: "250px",
                            ml: 2,
                        }}
                    >
                        <Tooltip title={t("back-main-page")}>
                            <Button onClick={toMainMenu}>
                                <img
                                    src={theme.logo}
                                    alt="Logo AI4Legal"
                                    height={40}
                                    style={{padding: "4px"}}
                                />
                            </Button>
                        </Tooltip>
                        {status === "authenticated" &&
                            session.user.role !== "NO_LICENCE" && <CasesDrawer />}
                    </Box>
                    <Box
                        sx={{
                            position: "absolute",
                            right: 0,
                            zIndex: 10,
                            width: {xs: "100vw", sm: "55vw", md: "35vw", lg: "20vw"},
                        }}
                    >
                        <DrawersController
                            setOpenDrawer={setOpenDrawer}
                            setOpenUserDrawer={setOpenUserDrawer}
                            setOpenMenu={setOpenMenu}
                            openUserDrawer={openUserDrawer}
                            openMenu={openMenu}
                            openDrawer={openDrawer}
                        />
                    </Box>
                </>
            )}
        </>
    );
}
